export enum AvailableLanguageKeys {
    en = 'en',
}
